import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Student } from 'src/app/model/student.model';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TeacherService } from '../teacher/teacher.service';
import { SafeHtml } from '@angular/platform-browser';
import { HomeService } from '../home/home.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'find-student-list',
  templateUrl: './find-students-list.component.html',
  styleUrls: ['./find-students-list.component.scss'],
})
export class FindStudentListComponent implements OnInit {

  searchedStudentName: string = "All";
  language: string;
  textDir: string;
  private destroy$ = new Subject<void>();

  @Input() status: string;
  allStudentsObjects: Student[] = [];
  currentDisplayStudentObjects: Student[] = [];
  tableReady: boolean = false;
  items = [];
  pageOfItems: Array<any>;
  safeAvatarSVG: SafeHtml;

  displayedColumns: string[] = [
    'findStudents.studentImage',
    'findStudents.studentFullName',
    'findStudents.studentUsername',
    //'findStudents.age',
    'findStudents.studentAction'
  ];

  constructor(
      private router: Router,
      private translate: TranslateService,
      private teacherService: TeacherService,
      private snackBar: MatSnackBar,
      private homeService: HomeService
    ) {
    this.language = translate.currentLang;
    translate.onLangChange.pipe(takeUntil(this.destroy$))
        .subscribe(({ lang }) => {
          this.language = lang
          if (this.language === 'ar'){
            this.textDir = 'rtl';
          }
          else {
            this.textDir = 'ltr';
          }
        });
  }
  
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.fetchAllStudents();
  }

  fetchAllStudents(): void {
    this.teacherService.getAllStudents("PENDING").subscribe((allStudents: Student[]) => {
      //console.log(allStudents);
      this.safeAvatarSVG = this.homeService.getAvatarImage();
      this.allStudentsObjects = allStudents;
      this.items = this.allStudentsObjects;
      this.filterStudents();
      this.displayTable();
    });
  }

  filterStudents(): void {
    //debugger;
    this.currentDisplayStudentObjects = [];

    //
    for (var i = 0; i < this.allStudentsObjects.length; i++) {

      var currentStudentName = this.allStudentsObjects[i].name;
      var currentStudentUserName = this.allStudentsObjects[i].username;

      if (this.searchedStudentName != "All"){
        if (currentStudentName.trim().toLocaleLowerCase().includes(this.searchedStudentName.trim().toLocaleLowerCase())
            ||
            currentStudentUserName.trim().toLocaleLowerCase().includes(this.searchedStudentName.trim().toLocaleLowerCase())
        ) {
          this.currentDisplayStudentObjects.push(this.allStudentsObjects[i]);
        }
      }else {
        this.currentDisplayStudentObjects.push(this.allStudentsObjects[i]);
      }
      
    }
  }

  displayTable(){
    this.tableReady = true;
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  callAddFriend(username){
    //console.log(username);
    let studentInfo: Student ;
    for (var i = 0; i < this.currentDisplayStudentObjects.length; i++) {

      var currentStudentName = this.currentDisplayStudentObjects[i].username;
      if (currentStudentName == username) {
        studentInfo = this.currentDisplayStudentObjects[i];
        break;
      }
      
    }
    let teacherInfo = JSON.parse(localStorage.getItem("avatarUser"));
    studentInfo.teacherId = teacherInfo.teacherId;
    studentInfo.status = "READY_TO_CONNECT";
    this.updateStudentInfo(studentInfo);
  }

  updateStudentInfo(studentInfo: Student){
    this.teacherService.updateStudentInfo(studentInfo)
    .subscribe((response: Student)=> {
      //localStorage.setItem("user", JSON.stringify(response))
      this.snackBar.open("Request Sent to Student", "", {duration: 2000});
      this.fetchAllStudents();
    }); 
  }

  applyFilter() {
    this.filterStudents();
    this.pageOfItems = this.currentDisplayStudentObjects;
  }
}
